import { USER_ROLES, UserRoleType } from "@/models/user";

export const FORMATTED_ROLES: { [key: string]: UserRoleType } = {
  ADMIN: USER_ROLES.admin,
  CONTROLLER: USER_ROLES.controller,
  "FIELD SERVICE AGENTS": USER_ROLES.fieldServiceAgents,
  MANAGER: USER_ROLES.manager,
  CUSTOMER: USER_ROLES.customer,
};
